const API_URL = import.meta.env.VITE_API_URL;
const API_WORKLOAD_URL = import.meta.env.VITE_API_WORKLOAD_URL;
const rollbarAccessToken = import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN;

if (rollbarAccessToken == null) {
  throw new Error('VITE_ROLLBAR_ACCESS_TOKEN env variable is not defined');
}

if (API_URL == null) {
  throw new Error('VITE_API_URL env variable is not defined');
}

if (API_WORKLOAD_URL == null) {
  throw new Error('VITE_API_WORKLOAD_URL env variable is not defined');
}

// Base for cookie-bearing auth calls (login, MFA, refresh, logout, onboarding). In hosted
// builds the SPA hits its OWN origin, which server.js reverse-proxies to the API, so the
// httpOnly refresh cookie is FIRST-PARTY and Safari/Firefox (which block third-party cookies)
// keep the session. In Vitest and local dev there is no proxy (and the API is same-site), so
// call the API directly — this also keeps the URL matching the test mocks. Trailing slash is
// stripped so the `${authUrl}/auth/...` calls never produce a double slash (VITE_API_URL is
// stored with a trailing slash). See apps/saas_front/server.js auth proxy.
const authBase =
  import.meta.env.VITEST || import.meta.env.DEV || typeof window === 'undefined' ? API_URL : window.location.origin;

const config = {
  apiUrl: API_URL,
  authUrl: authBase.replace(/\/+$/, ''),
  // Optional: when unset the "Sign in with Google" button is hidden. Already provisioned
  // as a build arg in Dockerfile/cloudbuild.yaml (_VITE_GOOGLE_SSO_OAUTH_CLIENT_ID).
  googleSsoClientId: import.meta.env.VITE_GOOGLE_SSO_OAUTH_CLIENT_ID as string | undefined,
  // Optional: when unset the "Sign in with Microsoft" button is hidden. Set once the Entra
  // app registration exists (build arg _VITE_MICROSOFT_SSO_OAUTH_CLIENT_ID).
  microsoftSsoClientId: import.meta.env.VITE_MICROSOFT_SSO_OAUTH_CLIENT_ID as string | undefined,
  workloadApiUrl: API_WORKLOAD_URL,
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  rollbarAccessToken,
  hostUrl: import.meta.env.VITE_RELIF_URL,
  // Mueve Seguro back-office chat (Insurex Chatter). Hardcoded — feature scoped to BU 39 only.
  mueveSeguroChatterUrl: 'https://chatter.grupoinsurex.cl',
};

export default config;
